import {Component, Input, OnInit} from '@angular/core';
import { FavoritesButtonVm } from 'src/app/view-model/favorites-button/favorites-button.vm';
import { UpdateFavoritesEvent } from '../../event-listeners/update-favorites/update-favorites.event';
import { UpdateSessionModalEvent } from '../../event-listeners/update-session-modal/update-session-modal.event';
import { GoogleTagService } from '../../../../data/networking/services/shared/google-tag/google-tag.service';

@Component({
  selector: 'app-favorites-button',
  templateUrl: './favorites-button.component.html',
  styleUrls: ['./favorites-button.component.scss'],
})
export class FavoritesButtonComponent implements OnInit {

  @Input() product;
  @Input() border = true;
  @Input() isMini = false;
  productFavorite = false;
  activeAnimation = false;

  constructor(
    private vm: FavoritesButtonVm,
    private eventFavorites: UpdateFavoritesEvent,
    private sessionModalStatusEvent: UpdateSessionModalEvent,
    private gtm: GoogleTagService) {  }

  ngOnInit() {
    this.productFavorite = this.vm.isFavorite(this.product);
  }

  addRemoveFavorite() {
    if (this.vm.hasCustomer()) {
      this.activeAnimation = true;
      setTimeout(() => {
        this.activeAnimation = false;
      }, 2500);
      this.productFavorite = !this.productFavorite;
      this.product.isFavorite = this.productFavorite;
      this.gtm.addRemoveFavorite(this.product);
      this.vm.addRemove(this.product).subscribe( res => {
        this.eventFavorites.updateEventFavorites({update: true});
      });
    } else {
      this.sessionModalStatusEvent.changeModalStatus({open: true});
    }
  }

}
